import { Types as TYPES } from '../types';
import { States as STATES } from '../states';

const actionType = TYPES.find((type) => type.actionName === 'tentAction');

const {
    ALL_TENT_FETCH_START,
    ALL_TENT_FETCH_SUCCESS,
    ALL_TENT_FETCH_FAILED,
    ALL_TENT_FETCH_STOP,
    SINGLE_TENT_FETCH_START,
    SINGLE_TENT_FETCH_SUCCESS,
    SINGLE_TENT_FETCH_FAILED,
    SINGLE_TENT_FETCH_STOP,
    TENT_CREATE_START,
    TENT_CREATE_SUCCESS,
    TENT_CREATE_FAILED,
    TENT_CREATE_STOP,
    TENT_UPDATE_START,
    TENT_UPDATE_SUCCESS,
    TENT_UPDATE_FAILED,
    TENT_UPDATE_STOP,
    TENT_DELETE_START,
    TENT_DELETE_SUCCESS,
    TENT_DELETE_FAILED,
    TENT_DELETE_STOP,
    RESET_TENT_STATUS,
    UPDATE_TENT_LOCALLY,
    PARTICIPANT_ASSIGNMENT_START,
    PARTICIPANT_ASSIGNMENT_FAILED,
    PARTICIPANT_ASSIGNMENT_SUCCESS,
    PARTICIPANT_DETACHMENT_START,
    PARTICIPANT_DETACHMENT_FAILED,
    PARTICIPANT_DETACHMENT_SUCCESS,
} = actionType.types;

const reducerState = STATES.find(
    (state) => state.reducerName === 'tentReducer'
);
const { initialState } = reducerState;

export default function tentReducer(state = initialState, action) {
    switch (action.type) {
        case ALL_TENT_FETCH_START:
            return {
                ...state,
                status: 'all_tent_fetch_start',
            };
        case ALL_TENT_FETCH_SUCCESS:
            return {
                ...state,
                status: 'all_tent_fetch_success',
                allTentData: action.payload,
            };
        case ALL_TENT_FETCH_FAILED:
            return {
                ...state,
                status: 'all_tent_fetch_failed',
            };
        case ALL_TENT_FETCH_STOP:
            return {
                ...state,
                status: 'all_tent_fetch_stop',
            };
        case SINGLE_TENT_FETCH_START:
            return {
                ...state,
                status: 'single_user_fetch_start',
            };
        case SINGLE_TENT_FETCH_SUCCESS:
            return {
                ...state,
                status: 'single_tent_fetch_success',
                singleTentData: action.payload,
            };
        case SINGLE_TENT_FETCH_FAILED:
            return {
                ...state,
                status: 'single_tent_fetch_failed',
            };
        case SINGLE_TENT_FETCH_STOP:
            return {
                ...state,
                status: 'single_tent_fetch_stop',
            };
        case TENT_CREATE_START:
            return {
                ...state,
                status: 'tent_create_start',
            };
        case TENT_CREATE_SUCCESS:
            return {
                ...state,
                status: 'tent_create_success',
                tentCreateData: action.payload,
                allTentData: [...state.allTentData, action.payload],
            };
        case TENT_CREATE_FAILED:
            return {
                ...state,
                status: 'tent_create_failed',
                error: action.payload,
            };
        case TENT_CREATE_STOP:
            return {
                ...state,
                status: 'tent_create_stop',
            };
        case TENT_UPDATE_START:
            return {
                ...state,
                status: 'tent_update_start',
            };
        case TENT_UPDATE_SUCCESS:
            return {
                ...state,
                status: 'tent_update_success',
                tentUpdateData: action.payload,
                allTentData: state.allTentData.map((tent) =>
                    tent.id === action.payload.id
                        ? { ...tent, ...action.payload }
                        : tent
                ),
            };
        case TENT_UPDATE_FAILED:
            return {
                ...state,
                status: 'tent_update_failed',
            };
        case TENT_UPDATE_STOP:
            return {
                ...state,
                status: 'tent_update_stop',
            };
        case TENT_DELETE_START:
            return {
                ...state,
                status: 'tent_delete_start',
            };
        case TENT_DELETE_SUCCESS:
            return {
                ...state,
                status: 'tent_delete_success',
                tentDeleteData: action.payload,
                allTentData: state.allTentData.filter(
                    (tent) => tent.id !== action.payload.id
                ),
            };
        case TENT_DELETE_FAILED:
            return {
                ...state,
                status: 'tent_delete_failed',
            };
        case TENT_DELETE_STOP:
            return {
                ...state,
                status: 'tent_delete_stop',
            };
        case RESET_TENT_STATUS:
            return {
                ...state,
                status: null,
                error: null,
            };
        case UPDATE_TENT_LOCALLY:
            return {
                ...state,
                allTentData: state.allTentData.map((tent) =>
                    tent.id === action.payload.id
                        ? { ...tent, ...action.payload }
                        : tent
                ),
            };
        case PARTICIPANT_ASSIGNMENT_START:
            return {
                ...state,
                status: 'participant_assignment_start',
            };
        case PARTICIPANT_ASSIGNMENT_SUCCESS:
            return {
                ...state,
                status: 'participant_assignment_success',
                participantAssignmentData: action.payload,
            };
        case PARTICIPANT_ASSIGNMENT_FAILED:
            return {
                ...state,
                status: 'participant_assignment_failed',
                error: action.payload,
            };
        case PARTICIPANT_DETACHMENT_START:
            return {
                ...state,
                status: 'participant_detachment_start',
            };
        case PARTICIPANT_DETACHMENT_SUCCESS:
            return {
                ...state,
                status: 'participant_detachment_success',
                participantDetachmentData: action.payload,
            };
        case PARTICIPANT_DETACHMENT_FAILED:
            return {
                ...state,
                status: 'participant_detachment_failed',
                error: action.payload,
            };
        default: {
            return {
                ...state,
            };
        }
    }
}
